"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var form_1 = require("../form");
// import * as Cropper from 'cropperjs';
var UploadController = /** @class */ (function (_super) {
    __extends(UploadController, _super);
    function UploadController($scope, book, uploads) {
        'ngInject';
        var _this = _super.call(this, $scope, book) || this;
        _this.uploads = uploads;
        _this.form.value = _this.book.get(_this.prefix, _this.id);
        uploads.setOption(_this.prefix, _this.id, $scope.option);
        $scope.$watch(function () { return uploads.uploads; }, function () {
            var upload = _this.uploads.getUpload(_this.prefix + "." + _this.id);
            var filename = upload ? upload.name : '';
            if (filename !== _this.form.value) {
                _this.setValue(filename);
            }
        }, true);
        $scope.$watch(function () { return _this.form.isDisabled(); }, function (value) {
            if (value) {
                _this.uploads.resetUpload(_this.prefix + "." + _this.id);
            }
        }, true);
        return _this;
    }
    UploadController.prototype.setValue = function (value) {
        this.form.value = value;
        this.book.set(this.prefix, this.id, this.form.value);
    };
    UploadController.prototype.onChange = function () {
        // pass file to uploads service:
        var file = this.form.value;
        this.form.value = this.book.get(this.prefix, this.id);
        if (!file) {
            return;
        }
        this.uploads.setFileRef(this.prefix, this.id, file);
    };
    UploadController.prototype.getThumbnail = function () {
        return this.uploads.getThumbnail(this.prefix + "." + this.id);
    };
    return UploadController;
}(form_1.FormOptionController));
exports.UploadController = UploadController;
function UploadDirective(config) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/upload.html',
        controller: UploadController,
        controllerAs: 'uploadCtrl'
    };
}
exports.UploadDirective = UploadDirective;
